import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useShellAside } from '../../layout/ShellAside';
import AffiliateAside, { SECTIONS } from './AffiliateAside';
import useAffiliateAccess from './useAffiliateAccess';

/**
 * Layout route for `/affiliate/*`. It exists only to hang the section aside on
 * the shell for as long as any Affiliate page is mounted — the aside tracks the
 * current route through its own NavLinks, so it is published once.
 */
export default function AffiliateLayout() {
  useShellAside(() => <AffiliateAside />, []);
  // `GET /affiliate/user/status/`, asked as the section opens: which pages
  // this affiliate gets (see useAffiliateAccess).
  const { ready, canSee, home } = useAffiliateAccess();
  const { pathname } = useLocation();

  // A page the status doesn't allow — opened by its address, or the
  // section's own link — goes to the first page this affiliate does get. The
  // deepest section the path is under decides.
  const section = SECTIONS.filter(
    (s) => pathname === s.to || pathname.startsWith(`${s.to}/`),
  ).sort((a, b) => b.to.length - a.to.length)[0];
  if (ready && section && !canSee(section.to)) return <Navigate to={home} replace />;

  return <Outlet />;
}
